// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"714":"497c3475","743":"27fcf7d5","2021":"769de09c","7513":"27fcf7d5","7584":"99833e91","9314":"99833e91"}[chunkId] + ".chunk.css";
};